import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogCheckboxPayload {
  checkbox_value: boolean;
}

export type ConfirmDialogResult = boolean | ConfirmDialogCheckboxPayload;

@Component({
  templateUrl: './confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmComponent {
  public data: any = {
    confirmText: 'yes',
    cancelText: 'no',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private readonly dialogRef: MatDialogRef<ConfirmComponent>,
  ) {
    this.data = { ...this.data, ...modalData };
  }

  protected onConfirm(): void {
    let result: ConfirmDialogResult = true;

    if (this.data.checkbox) {
      result = {
        checkbox_value: this.data.checkbox.value,
      };
    }

    this.dialogRef.close(result);
  }
}
